/**
 * Per-restaurant menu editor moved to Business Admin.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/menus/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/business-admin", search: { tab: "menus", place: params.slug } });
  },
});
